<template>
  <form
    class="form form--flex"
    @submit.prevent="submitForm"
  >
    <div class="form__row">
      <div class="form__column--half">
        <label
          for="first_name"
          class="hidden-text"
        >First Name</label>
        <input
          id="first_name"
          v-model="fields.first_name"
          type="text"
          class="form__input form__input--light"
          :class="{ 'has-error': errors.first_name }"
          name="first_name"
          placeholder="First Name"
        >
        <div
          v-if="errors && errors.first_name"
          class="form__message form__message--error"
        >
          {{ errors.first_name[0] }}
        </div>
      </div>
      <div class="form__column--half">
        <label
          for="last_name"
          class="hidden-text"
        >Last Name</label>
        <input
          id="last_name"
          v-model="fields.last_name"
          type="text"
          class="form__input form__input--light"
          :class="{ 'has-error': errors.last_name }"
          name="last_name"
          placeholder="Last Name"
        >
        <div
          v-if="errors && errors.last_name"
          class="form__message form__message--error"
        >
          {{ errors.last_name[0] }}
        </div>
      </div>
    </div>

    <div class="form__row">
      <div class="form__column--full">
        <label
          for="email"
          class="hidden-text"
        >Email</label>
        <input
          id="email"
          v-model="fields.email"
          type="email"
          class="form__input form__input--light"
          :class="{ 'has-error': errors.email }"
          name="email"
          placeholder="Email"
        >
        <div
          v-if="errors && errors.email"
          class="form__message form__message--error"
        >
          {{ errors.email[0] }}
        </div>
      </div>
    </div>

    <div class="form__row">
      <div class="form__column--full">
        <label
          for="message"
          class="hidden-text"
        >Message</label>
        <textarea
          id="message"
          v-model="fields.message"
          class="form__input form__input--light"
          :class="{ 'has-error': errors.message }"
          name="message"
          placeholder="Message"
        />
        <div
          v-if="errors && errors.message"
          class="form__message form__message--error"
        >
          {{ errors.message[0] }}
        </div>
      </div>
    </div>

    <div class="form__row">
      <div class="form__column--full">
        <vue-hcaptcha
          ref="invisibleHcaptcha"
          sitekey="ff3175d8-bb30-44fd-9266-989b2dc90def"
          data-callback="submitForm"
          @verify="onVerify"
        />
        <div
          v-if="errors && errors['h-captcha-response']"
          class="form__message form__message--error"
        >
          {{ errors['h-captcha-response'][0] }}
        </div>
      </div>
    </div>

    <div class="form__row">
      <div class="form__column--full">
        <button
          class="form__button form__button--orange"
          type="submit"
          :disabled="!loaded"
        >
          <template v-if="loaded">
            Submit
          </template>
          <template v-else>
            Sending...
          </template>
        </button>

        <div
          v-if="success"
          class="form__message form__message--success"
        >
          Message sent!
        </div>
        <div
          v-if="errors && errorMessage"
          class="form__message form__message--error"
        >
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

export default {
  components: {
    VueHcaptcha,
  },
  props: {
    webRoutes: { required: true, type: Object },
  },
  data() {
    return {
      fields: {},
      errors: {},
      errorMessage: null,
      success: false,
      loaded: true,
      verified: false,
    };
  },

  methods: {
    onVerify(response) {
      this.verified = true;
      this.fields['h-captcha-response'] = response;
    },
    requestSubmit() {
      return axios.post(this.webRoutes.submit, this.fields);
    },
    submitForm() {
      if (this.loaded) {
        this.loaded = false;
        this.success = false;
        this.errorMessage = null;
        this.errors = {};
        this.verified = true;

        this.requestSubmit()
          .then((response) => {
            this.fields = {}; //Clear input fields.
            this.loaded = true;
            this.success = true;
            this.verified = false;
          })
          .catch((error) => {
            this.loaded = true;
            this.verified = false;
            if (error.response.status === 422) {
              this.errors = error.response.data.errors || {};
              this.errorMessage = error.response.data.message;
            }
          });
      }
    },
  },
};
</script>
